export const SET_INPLOCATION = "SET_INPLOCATION";
export const GET_INPLOCATION = "GET_INPLOCATION";

export const SET_GEOLOCATION = "SET_GEOLOCATION";
export const GET_GEOLOCATION = "GET_GEOLOCATION";

export const SET_FEEDBACK = "SET_FEEDBACK";
